import { render, staticRenderFns } from "./printreferpatient.vue?vue&type=template&id=4116ee24"
import script from "./printreferpatient.vue?vue&type=script&lang=js"
export * from "./printreferpatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports